import React, { useState, Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import { ReactComponent as Close } from "../../../../assets/images/icons/close.svg";
import Button from "../../../buttons/buttons";
import Input from "../../../inputs/inputs";
import { Beat } from "../../../../plugins/spinners.plugin";
import { editDeliveryMode, deleteDeliveryMode } from "../../../../redux/deliveryMode/deliveryModeAction";

export function EditDeliveryModeModal({ deliveryMode, onSuccess }) {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.deliveryMode);
  const [isOpen, setIsOpen] = useState(false);
  const [input, setInput] = useState({ title: "", description: "" });

  useEffect(() => {
    if (deliveryMode) {
      setInput({
        title: deliveryMode.title || "",
        description: deliveryMode.description || "",
      });
    }
  }, [deliveryMode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));
  };

  const handleDelete = async () => {
    const response = await dispatch(deleteDeliveryMode({ id: deliveryMode?.id }));
    if (response?.status === "success") {
      setIsOpen(false);
      onSuccess && onSuccess();
    }
  };
  const handleSubmit = async () => {
    const response = await dispatch(editDeliveryMode({ id: deliveryMode?.id, ...input }));
    if (response?.status === "success") {
      setIsOpen(false);
      onSuccess && onSuccess();
    }
  };

  return (
    <>
      <button
        type="button"
        className="text-primary underline text-sm"
        onClick={() => setIsOpen(true)}
      >
        Edit
      </button>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={() => setIsOpen(false)}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100"
            leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300" enterFrom="opacity-0 translate-y-4 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200" leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:scale-95"
              >
                <Dialog.Panel className="relative w-[358px] sm:w-[520px] bg-white dark:bg-[#121212] rounded-sm py-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8">
                  <div className="sm:block absolute top-4 right-5">
                    <button
                      type="button"
                      className="bg-[#ffeae5] dark:bg-[#CE2600] rounded-md p-1 sm:p-3"
                      onClick={() => setIsOpen(false)}
                    >
                      <span className="sr-only">Close</span>
                      <Close className="w-4 h-4 white-icon" />
                    </button>
                  </div>

                  <div className="mt-2 sm:px-8">
                    <Dialog.Title as="p" className="text-[22px] font-medium text-[#717485] dark:text-white">
                      Edit Delivery Mode
                    </Dialog.Title>
                  </div>

                  <div className="border-b-2 mt-4" />

                  <div className="mt-6 px-8 space-y-4">
                    <Input.Label
                      title="Title"
                      name="title"
                      id="edit-title"
                      htmlFor="edit-title"
                      type="text"
                      placeholder="Enter title"
                      value={input.title}
                      onChange={handleChange}
                      className="w-full"
                    />
                    <Input.Label
                      title="Description"
                      name="description"
                      id="edit-description"
                      htmlFor="edit-description"
                      type="text"
                      placeholder="Enter description"
                      value={input.description}
                      onChange={handleChange}
                      className="w-full"
                    />
                    
                    <div className="flex gap-4 justify-end pt-4 pb-2">
                      <Button.Secondary
                        type="button"
                        title={loading ? <Beat color={"#FFFFFF"} /> : "Delete"}
                        disabled={loading || !input.title}
                        onClick={handleDelete}
                      />
                      <Button.Primary
                        type="button"
                        title={loading ? <Beat color={"#FFFFFF"} /> : "Save Changes"}
                        disabled={loading || !input.title}
                        onClick={handleSubmit}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
